<div class="row text-center mb-3 mt-5">
  <div class="col d-flex justify-content-center">
    <h2 class="font liteGray">Contact Us</h2>
  </div>
</div>

<div class="container">
  <div class="row justify-content-center">
    <div class="font-roboto col-sm-12 col-md-5 foot-deets footer-contact">
      <img alt="Contact Icon" src="assets/images/iconfinder_ic_contact_phone_48px_3669371.svg">
      <p class="footer-contact-text">
        <strong>Lissa Gilmore</strong><br/>
        Principal<br/>
        Outdoor Ed and Environmental Literacy<br/>
        Sky Mountain<br/>
        <a href="mailto:lgilmore@sjcoe.net">lgilmore@sjcoe.net</a><br/>
        <a href="tel:2096873223">(209) 687-3223</a>
      </p>
    </div>

    <div class="font-roboto col-sm-12 col-md-5 foot-deets footer-contact">
      <img alt="Address Icon" src="../../../assets/images/iconfinder_icon-map_211858.svg">
      <p class="footer-contact-text">
        <strong>Address</strong><br/>
        45700 Six Mile Valley Rd<br/>
        Emigrant Gap, CA 95715
      </p>
    </div>

    <div class="font-roboto col-sm-12 col-md-2 foot-deets footer-contact">
      <img alt="STEM Programs Icon" src="../../../assets/images/iconfinder_icon-map_211858.svg">
      <p class="footer-contact-text">
        <strong>STEM Programs</strong><br/>
        PO Box 213030<br/>
        Stockton, CA 95213<br/>
        <a href="tel:2094684880">(209) 468-4880</a>
      </p>
    </div>
  </div>

  <!-- social icons -->
  <div class="row mt-2">
    <div class="col d-flex justify-content-center align-items-center iconGap">
      <a href="https://www.facebook.com/SJCOESTEM" target="_blank" rel="noopener" aria-label="faceBook icon">
        <fa-icon [icon]="faFacebookF" style="font-size: 32px; color: #165884;" alt="faceBook icon"></fa-icon>
      </a>
      <a href="https://sites.google.com/view/caoutdoorschoolassociation/home" target="_blank" rel="noopener" aria-label="COSA Icon">
        <img src="../../../../assets/images/COSABannerLogo.png" alt="California Outdoor School Association" style="height: 40px; width: 119px;"/>
      </a>
    </div>
  </div>
</div>

<div class="col text-center">
  <a href="https://www.sjcoe.org/" target="_blank">
    <img src="assets/images/SJCOE-Formal.png" style="width:400px;" alt="SJCOE Logo"/>
  </a>
</div>

<div class="footer">
  <img src="assets/images/FooterBackground-01.png" alt="FooterBackground" style="width: 100%;"/>
</div>